import { isBusinessCustomer, isIndividualCustomer } from 'pages/NestedCustomers/utils'
import { formatAmount } from 'pages/Rewards/utils'
import { CardStatus } from 'services/CardService'
import { Balance, NestedCustomerDetails } from 'types/customers'

export const getStatusHighlightProps = (status: CardStatus) => {
  switch (status) {
    case 'ACTIVE':
      return { type: 'success' as const, labelKey: 'customers.cardDetails.statusActive' }
    case 'FROZEN':
      return { type: 'warning' as const, labelKey: 'customers.cardDetails.statusFrozen' }
    case 'BLOCKED':
      return { type: 'error' as const, labelKey: 'customers.cardDetails.statusBlocked' }
    case 'CANCELLED':
      return { type: 'neutral' as const, labelKey: 'customers.cardDetails.statusCancelled' }
    default:
      return { type: 'neutral' as const, labelKey: 'customers.cardDetails.statusUnknown' }
  }
}

export const formatWalletBalance = (balance: Balance): string =>
  `${formatAmount(Number(balance.value))} ${balance.currencyCode}`

export const getCardholderName = (customer?: NestedCustomerDetails): string => {
  if (!customer) return ''
  if (isIndividualCustomer(customer)) {
    const { firstName, lastName } = customer.individual.person
    return [firstName, lastName].filter(Boolean).join(' ')
  }
  if (isBusinessCustomer(customer)) {
    return customer.company.name
  }
  return ''
}

export const formatExpiryDate = (expiresAt: string): string => {
  if (!expiresAt) return ''
  const [year, month] = expiresAt.split('-')
  if (!year || !month) return expiresAt
  return `${month}/${year.slice(-2)}`
}

export const isFreezeDisabled = (status: CardStatus) =>
  status === 'BLOCKED' || status === 'CANCELLED' || status === 'EXPIRED'
